import './VideoEdu.scss';
import * as S from '../scss/theme';
import fnc from '../mymod/commFunction';
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import HongButton from '../comm/HongButton';
import HeaderTitle from '../comm/HeaderTitle';
import imgYoutube from '../images/svg/youtube.svg';
import VideoPlayer_child from '../video/VideoPlayer_child';
import VideoEdu_detail from './VideoEdu_detail';

const VideoEdu = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const videoEduKind = useSelector((state) => state.reduxIgong.videoEduKind);
  const selectedUserInfo = useSelector((state) => state.reduxIgong.selectedUserInfo);
  const [list, setList] = useState([]);
  const [kind, setKind] = useState(null);
  const [title, setTitle] = useState(null);
  const [title2, setTitle2] = useState(null);
  const [url, setUrl] = useState(null);
  const [selectedCode, setSelectedCode] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);
  const [isModal_play, setIsModal_play] = useState(false);
  const [isModal_detail, setIsModal_detail] = useState(false);
  const [childUrlList, setChildUrlList] = useState([]);
  const stCode = selectedUserInfo.stCode

  useEffect(() => {

    if (videoEduKind && stCode) {
        fncSelect_list(videoEduKind, stCode);
        const resTitle = getTitle(videoEduKind);
        setTitle(resTitle);
    }
   
  }, []);

function getTitle(videoEduKind) {
  switch (videoEduKind) {
    case 'aca':
      return '교사인증 코칭교육 프로그램';//원장용
    case 'tec':
      return '프로코치 교사인증 프로그램';//교사용
    case 'mom':
      return '자녀교육 코칭 프로그램';//학생용
    default:
      return '';
  }
}


  function fncSelect_list(kind, stCode) {
    fnc.sendAxios('/videoEduRoutes/select/video_eduProgram_unit1', { kind, stCode }, (res) => {
      console.log(res, 'video_eduProgram_unit1 watchRate');
      if (res && Array.isArray(res)) {
        const newList = getRecords(res);
        console.log(res);
        setList(newList);
      } else {
        alert('검색에 실패했습니다.');
      }
    });
  
    function getRecords(res) {
      const records = [];
      res.forEach(item => {
      const sno = item["sno"];
      const no = item["no"];
      const pCode = item["pCode"];
      const code = item["code"];
      const title = item["title"];
      const url = item["url"];
      const kind = item["kind"];
      const isParent = item["isParent"];
      const watchRate = item["watchRate"];
        records.push({ sno, no, pCode, code, title, url, kind, isParent, watchRate });
      });
      return records;
    }
  }

  function onPlay(item) {
    // setTitle2(`${item.no}. ${item.title}`);
    setTitle2(`${item.title}`);
    setUrl(item.url);
    setSelectedCode(item.code); // 또는 item.sno
    // setIsModal_play(true);
    setSelectedItem(item);//부모 code 알기위해 진행률 저장 땜에
    fncSelect_list_child(item.code, selectedUserInfo.stCode);
  }

  const handlePlay = () => {
      // 조회수 업데이트 로직
      // console.log("비디오 재생 시작");
      // setViews(views + 1); // 조회수 1 증가
      // 여기서 백엔드 API를 호출하여 실제 조회수를 업데이트할 수 있음
  };

  function onDetail(item) {
    setSelectedItem(item);
    setSelectedCode(item.code);//css용
    setIsModal_detail(true);
    
  }


  
  function fncSelect_list_child(pCode, stCode) {
    fnc.sendAxios('/videoEduRoutes/select/video_eduProgram_child', { pCode, stCode }, (res) => {
      if (res && Array.isArray(res)) {

        console.log(res, '-------child');
        const newList = getRecords(res);
        setChildUrlList(newList);

        setIsModal_play(true);
        // setList(newList);
      } else {
        alert('검색에 실패했습니다.');
      }
    });
  
    function getRecords(res) {
      const records = [];
      res.forEach(item => {
      const pCode = item["pCode"];
      const code = item["code"];
      const title = item["title"];
      const url = item["url"];
      const isParent = item["isParent"];
      const watchRate = item["watchRate"];
      
        records.push({ pCode, code, title, url, isParent, watchRate });
      });
      return records;
    }
  }
  
//=========================================
  return (

  <S.Section>
     <HeaderTitle  title={title} direction={1} onBackClick={() => navigate(-1)} />
    <div className='VideoEdu'>
      <section className='sec-main'>
                    <table className="table-hong table-main">
                    {/* <thead>
                        <tr>
                        <th>No</th>
                        <th>제목</th>
                        <th>영상</th>
                        <th>상세</th>
                        </tr>
                    </thead> */}

                    <tbody>
                        {list && list.map((item, index) => (
        
                            <tr key={index} className={item.code === selectedCode ? 'selected-row' : ''}>  
                                {/* <td>{item.no}</td> */}
                                {/* <td>{item.title}</td> */}
                                <td>
                                  <div className={item.isParent === 'Y' ? 'parent' : 'child'}
                                    onClick={() => onPlay(item)}>
                                      {item.no} {item.title}
                                  </div>
                                
                                </td>

                                {/* <td>
                                    <HongButton 
                                        className="btnPlay" 
                                        startIcon={<img src={imgYoutube} alt="play" />}   
                                        onClick={() => onPlay(item)} >  
                                    </HongButton>
                                </td> */}


                                {/* <td>
                                    <HongButton 
                                        className="btnReport h-btn-black"
                                        onClick={() => onDetail(item)} >상세
                                    </HongButton>
                                </td> */}


                            </tr>
                        ))}
                    
                        </tbody>

                    </table>

                </section> 

    </div>


     {isModal_play && (
            <S.Modal_pc>
                <HeaderTitle  title={title2 + ''} direction={1} 
                onBackClick={() => setIsModal_play(false)} />
               <article className='art-video'>
                      <VideoPlayer_child 
                          url={url} 
                          selectedItem={selectedItem}
                          onPlay={handlePlay} 
                          childUrlList={childUrlList}
                         
                      />
                </article>    
            </S.Modal_pc>
      )}

      {/* {isModal_detail && (
            <S.Modal_pc>
                <HeaderTitle  title={selectedItem.title } direction={1} 
                onBackClick={() => setIsModal_detail(false)} />
               
                <VideoEdu_detail selectedItem={selectedItem} />
               
            </S.Modal_pc>
      )} */}


    
  </S.Section>


  );
};

export default VideoEdu;